const BUTTON_FADE_IN_DURATION_MS = 100;
const USERAREA_ENTER_DURATION_MS = 225;
const USERAREA_EXIT_DURATION_MS = 100;
const userAreaTransitionCls = "_275uvmoivy";

export { BUTTON_FADE_IN_DURATION_MS, USERAREA_ENTER_DURATION_MS, USERAREA_EXIT_DURATION_MS, userAreaTransitionCls };
import "./transition.user-area.style.linaria.module.css";
//# sourceMappingURL=transition.user-area.style.js.map
